import React from "react";
import VAFamily from "../../PicesForPages/VA_family.jpg";
import FreeConsultation from "../Form/FreeConsultation";
import { Link } from "react-router-dom";

function VALoans() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent VALoansPageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={VAFamily}
          alt="FHAFamilyImage"
          className="background-video VA_FamilyImage"
        />
        <div className="purchasetopBox VALoansPageTopBox">
          {/* The existing Purchase span */}
          <span>VA Loans</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftContent">
              VA mortgage loans are among the most reliable and beneficial
              options for purchasing a home. Currently, even active duty members
              are eligible. Disabled Veterans may receive extra benefits when
              applying for a VA home mortgage loan. The VA Home Mortgage Program
              allows veterans to use the program multiple times without
              restriction.
            </span>
            <span className="purchaseBottomLeftContent">
              These VA mortgage loans are available to members of the Army,
              Navy, Air Force, Marines, Reservists, and National Guardsmen.
              Recent updates to the Veterans Benefit Act raised the VA loan
              limit to $510,400 for loans with no down payment and expanded
              eligibility and benefits for Veterans, active duty personnel, and
              Disabled Veterans.
            </span>

            <span className="purchaseBottomLeftHeader">
              Key advantages of the VA Mortgage Loan Program include:
            </span>
            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>
                A guarantee of no down payment required for loans up to $510,400
              </li>
              <li>No requirement for monthly Home Owner’s Insurance</li>
              <li>Many VA Mortgage Loans are assumable</li>
              <li>
                Qualification for a VA Loan is generally easier than for
                conventional loans
              </li>
              <li>VA Mortgage Loans offer refinancing options</li>
            </ul>

            <span className="purchaseBottomLeftSubHeader">
              No Down Payment Required for Loans up to $510,400
            </span>
            <span className="purchaseBottomLeftContent">
              You can obtain a VA Home Mortgage Loan without any down payment
              for amounts up to $510,400. If the seller agrees to cover the
              closing costs, you could potentially buy a home with no
              out-of-pocket expenses. The loan and sales agreement can be
              structured so that the VA Home Mortgage Loan covers the entire
              purchase price while the seller pays the closing costs.
            </span>

            <span className="purchaseBottomLeftSubHeader">VA Funding Fee</span>
            <span className="purchaseBottomLeftContent">
              The Veterans Administration applies a Funding Fee on all VA loans,
              ranging from 0.5% to 3%. Unlike FHA mortgages, which require a
              minimum 3.5% down payment, this fee is incorporated into the loan
              and paid over its term. This fee replaces the higher-priced
              Mortgage Insurance typical of conventional loans. Disabled
              Veterans might be eligible to have this fee waived.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Assumable VA Mortgage Loans
            </span>
            <span className="purchaseBottomLeftContent">
              VA loans can be assumed by another party. If the new borrower is a
              veteran with VA eligibility, the original veteran retains their
              entitlement amount used for the initial loan. It's essential for
              veterans to thoroughly understand the terms of a loan assumption
              before proceeding, as it’s a significant benefit to forfeit.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Qualifying for a VA Mortgage Loan
            </span>
            <span className="purchaseBottomLeftContent">
              The VA has favorable qualification standards, not relying on
              credit scoring for loan evaluation. Even those with past financial
              hardships and low credit scores may qualify if they have
              maintained a good payment history recently. This can lead to
              substantial savings compared to conventional loans for borrowers
              with lower credit scores.
            </span>

            <span className="purchaseBottomLeftSubHeader">
              Refinancing VA Mortgage Loans
            </span>
            <span className="purchaseBottomLeftContent">
              VA mortgage loans offer the option to refinance to a lower
              interest rate without the typical requirements of conventional
              loans. Through an Interest Rate Reduction Loan, veterans can
              secure a lower rate without needing credit checks, appraisals, or
              income and asset verification, and the transaction costs can be
              included in the loan, eliminating out-of-pocket expenses.
            </span>

            <div className="purchaseBottomLeftButton">
              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                className="purchaseBottomLeftButtonLink"
              >
                APPLY!
              </Link>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default VALoans;
